import { ACTION_POINT_PARAM } from '../../providers/param/registry-keys.js';
import { ParamRegistry } from '../../registries/param-registry.js';
import { PreHandlers } from '../../registries/pre-handler-registry.js';

/**
 * 获得当前 config name 中的命名参数信息
 *
 * @public
 * @decorator
 */
function Param(expression, useFunction) {
    return ParamRegistry.decorate(ACTION_POINT_PARAM, {
        expression,
        useFunction,
    });
}
PreHandlers.set(ACTION_POINT_PARAM, ({ param, runner }) => {
    var _a, _b, _c, _d;
    const { name } = runner.point;
    if (!((_a = runner.point.matchPoint) === null || _a === void 0 ? void 0 : _a.includes(':')))
        return undefined;
    if (param.expression) {
        const template = runner.point.matchPoint.replace(`:${param.expression}`, '(.+)').replace(/:\w+/g, '\\w+');
        const regexp = new RegExp(template);
        const value = name.match(regexp);
        if (value) {
            return (_c = (_b = param.converter) === null || _b === void 0 ? void 0 : _b.call(param, value[1])) !== null && _c !== void 0 ? _c : value[1];
        }
        return undefined;
    }
    const keys = runner.point.matchPoint.match(/:\w+/g);
    const template = runner.point.matchPoint.replace(/:\w+/g, '(\\w+)');
    const regexp = new RegExp(template);
    const [, ...values] = name.match(regexp);
    return (_d = keys === null || keys === void 0 ? void 0 : keys.reduce((acc, key, index) => {
        acc[key.slice(1)] = values[index];
        return acc;
    }, {})) !== null && _d !== void 0 ? _d : {};
});

export { Param };
//# sourceMappingURL=param.js.map
